import React, { useState, useEffect, useRef, forwardRef, } from "react";
import {Grid,
        Box,
        Tabs,
        Tab,
        AppBar,
        Typography,
        MenuItem,
        CircularProgress,
        Dialog,
        DialogActions,
        DialogContent,
        DialogContentText,
        DialogTitle,
} from "@material-ui/core";
import PropTypes from 'prop-types';
import { Button } from '../../components/Wrappers'
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import SendIcon from '@material-ui/icons/Send';
import CardMembershipIcon from '@material-ui/icons/CardMembership';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import HistoryIcon from '@material-ui/icons/History';
import BusinessIcon from '@material-ui/icons/Business';
import { useHistory } from "react-router-dom";
import classnames from "classnames";
import useStyles from './styles';
import ttAPI from '../../api/ttAPI';
import config from '../../config';
import Widget from '../../components/Widget';
import UpdateCustomer from '../../components/Customer/UpdateCustomer';
import CustomerOpenJobs from '../../components/Customer/CustomerOpenJobs';
import ClosedJobs from '../jobs/ClosedJobs';
import Sites from '../../components/Site/Sites';
import Assets from '../assets/Assets';
import { sendNotification } from "../../context/UserContext";
import CreateSite from '../../components/Site/CreateSite';
import CustomerDownloadCSVConfirmation from '../../components/CustomerDownloadCSVConfirmation/CustomerDownloadCSVConfirmation';

const EditCustomer = forwardRef((props, ref) => {

    const history = useHistory();
    const classes = useStyles();
    const [locationState, setLocationState] = useState(props.location.state);
    const [paramsId, setParamsId] = useState(props.match.params.id);
    const [customer, setCustomer] = useState(undefined);
    var [showOpenJobs, setShowOpenJobs] = useState(true);
    var [showClosedJobs, setShowClosedJobs] = useState(false);
    var [showAssets, setShowAssets] = useState(false);
    var [showSites, setShowSites] = useState(false);
    const [tabValue, setTabValue] = useState(0);
    const customerWidgetRef = useRef(null);
    const [openResetXeroContactDialog, setOpenResetXeroContactDialog] = useState(false);
    const [isResetingXeroContact, setIsResetingXeroContact] = useState(false);
    const customerDownloadCSVConfirmationRef = useRef(null);
    const [openCreateSiteDialog, setOpenCreateSiteDialog] = useState(false);
    const createSiteRef = useRef(null);
    const [isCreateSiteValid, setIsCreateSiteValid] = useState(false);
    const [isCreatingSite, setIsCreatingSite] = useState(false);
    const [customerCPI, setCustomerCPI] = useState();
    const [createdSite, setCreatedSite] = useState({
      id: -1,
      customer_id: -1,
      name: null,
      code: null,
      contact: null,
      phone: null,
      email: null,
      address: null,
      notes: null,
      mapurl: null,
      active: true
    });

    function TabPanel(props) {
      const { children, value, index, ...other } = props;

      return (
        <div
          role="tabpanel"
          hidden={value !== index}
          id={`simple-tabpanel-${index}`}
          aria-labelledby={`simple-tab-${index}`}
          {...other}
        >
          {value === index && (
            <Box p={3}>
              <Typography component="div">{children}</Typography>
            </Box>
          )}
        </div>
      );
    }

    TabPanel.propTypes = {
      children: PropTypes.node,
      index: PropTypes.any.isRequired,
      value: PropTypes.any.isRequired,
    };

    function a11yProps(index) {
      return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
      };
    }

    useEffect(() => {
        let mounted = true;
        const customerId = locationState === undefined ? paramsId : locationState.customerId;
        async function fetchData() {
            const response = await ttAPI.getCustomerById(customerId);
            if(mounted){
                setCustomer(response);
            }
        }

        async function getCustomerCPI() {
          const response = await ttAPI.getCustomerCPI(customerId);
          setCustomerCPI(response);
        }

        if (customerId !== undefined && customerId > 0) {
            fetchData();
            getCustomerCPI();

            // pre-set customer id to new site
            setCreatedSite({
              ...createdSite,
              customer_id: customerId,
            });
        }

        return () => mounted = false;
    },[locationState, paramsId]);

    function downloadCustomerAssetsCSV() {
      customerDownloadCSVConfirmationRef.current.openConfirmationPopup(customer.id, customer.name);
      customerWidgetRef.current.closeWidgetMoreMenu();
    }

    function viewCustomerForecast() {
      window.open(
      `${config.clientApi}/reports/forecast.pdf?customer_id=${customer.id}`,
      '_blank'
      );
      customerWidgetRef.current.closeWidgetMoreMenu();
    }

    function downloadCustomerCostEstimatorCSV() {
      window.open(
      `${config.clientApi}/reports/customer_cost_estimator?id=${customer.id}`,
      '_blank'
      );
      customerWidgetRef.current.closeWidgetMoreMenu();
    }


    function handleTabChange(event, newValue) {
      if (newValue === 0) {
          setShowOpenJobs(true);
          setShowClosedJobs(false);
          setShowAssets(false);
          setShowSites(false);
      }
      else if (newValue === 1) {
          setShowOpenJobs(false);
          setShowClosedJobs(true);
          setShowAssets(false);
          setShowSites(false);
      }
      else if (newValue === 2) {
          setShowOpenJobs(false);
          setShowClosedJobs(false);
          setShowAssets(true);
          setShowSites(false);
      }
      else if (newValue === 3) {
          setShowOpenJobs(false);
          setShowClosedJobs(false);
          setShowAssets(false);
          setShowSites(true);
      }
      setTabValue(newValue);
    }

    const handleCloseResetXeroContactDialog = () => {
      setOpenResetXeroContactDialog(false);
    };

    const resetXeroContact = async () => {
        setIsResetingXeroContact(true);
        const response = await ttAPI.resetXeroContact(customer.id);
        setIsResetingXeroContact(false);
        if (response) {
          refreshCustomer();
          sendNotification('success', 'Success - Xero Contact Removed Successfully.', classes);
          setOpenResetXeroContactDialog(false);
        }
        else {
          sendNotification('error', 'Error - Error Removing Xero Contact.', classes);
        }

    }

    function resetXeroContactConfirmation() {
      setOpenResetXeroContactDialog(true);
      customerWidgetRef.current.closeWidgetMoreMenu();
    }

    async function refreshCustomer() {
      setCustomer(null);
      const response = await ttAPI.getCustomerById(customer.id);
      setCustomer(response);
    }

    const downloadHistory = () => {
      if (customer.id === undefined) {
          sendNotification('error','Cannot download history, invalid customer id');
      }
      else {
          window.open(`${config.clientApi}/reports/audit/customer?id=${customer.id}`,'_blank');
      }


      customerWidgetRef.current.closeWidgetMoreMenu();
    }

    const handleCloseCreateSiteDialog = () => {
        setOpenCreateSiteDialog(false);
    };

    function onCreateSiteFormUpdated(isValid) {
      setIsCreateSiteValid(isValid);
    }

    function onCreateSiteUpdated(site) {
    }

    function onSiteCreated(sie, isUpdate, siteId) {
      sendNotification('success', isUpdate ? 'Success - Site Updated.' : 'Success - Site Created.', classes);
      history.push({pathname:`/app/site/edit/${siteId}`,
                                       state:{siteId: siteId}
                                     });
    }

    function handleOpenCreateSiteDialog() {
      setOpenCreateSiteDialog(true);
    }

    function createSite() {
      if (createSiteRef !== null && createSiteRef.current !== null) {
          createSiteRef.current.saveSite();
      }
    }

    function handleClose() {
      // nothing todo
    }


  return (
    <div className={classes.contentDiv}>

      {customer &&
        <Grid container spacing={4}>
            <Grid item xs={12} md={6} sm={6}>
            <Widget title={<><div className={classes.editCustomer}>
                       Customer &nbsp;
                       {customer.service_level_agreement && customerCPI &&
                       <>
                       <span className={classes.cpi}>
                       CPI: {customerCPI.customer_cpi_percentage} ({customerCPI.customer_cpi_quarter}) - applied {customerCPI.last_applied}.
                       </span>
                       {customerCPI.update_needed !== '' &&
                       <span className={classes.cpiError}
                             className={classnames({
                             [classes.cpiError]: !/no update/i.test(customerCPI.update_needed),
                             [classes.cpiNoUpdate]: /no update/i.test(customerCPI.update_needed)
                           })}
                       >&nbsp;[{customerCPI.update_needed}]</span>}
                       </>
                       }
                      </div>
                   </>}
                   ref={customerWidgetRef}
                    menuItems={<div><MenuItem onClick={handleOpenCreateSiteDialog}>
                                    <BusinessIcon/>&nbsp;<Typography>Create Site</Typography>
                                </MenuItem>
                                <MenuItem onClick={downloadHistory}>
                                    <HistoryIcon/>&nbsp;<Typography>Download History</Typography>
                                </MenuItem>
                                {customer.xero_contact_id !== undefined && customer.xero_contact_id !== null && <MenuItem onClick={resetXeroContactConfirmation}>
                                   <RemoveCircleIcon/>&nbsp;<Typography>Reset Xero Contact</Typography>
                                </MenuItem>}
                                  <MenuItem onClick={downloadCustomerAssetsCSV}>
                                      <SendIcon/>&nbsp;<Typography>View Assets CSV</Typography>
                                   </MenuItem>
                                   <MenuItem onClick={downloadCustomerCostEstimatorCSV}>
                                  <MonetizationOnIcon/>&nbsp;<Typography>View Cost Estimate CSV</Typography>
                                </MenuItem>

                               <MenuItem onClick={viewCustomerForecast}>
                                  <CardMembershipIcon/>&nbsp;<Typography>View Forecast</Typography>
                               </MenuItem>
                               </div>
                             }>
                <UpdateCustomer createdCustomer={customer} onUpdateSuccess={refreshCustomer}/>
                </Widget>
            </Grid>
            <Grid item xs={12} md={6} sm={6}>
                  <Widget
                   className={classes.formDisplay}
                   disableWidgetMenu noHeader>
                   <AppBar position="static" color="default" style={{ marginTop: 10 }}>
                     <Tabs value={tabValue}
                           onChange={handleTabChange}
                           indicatorColor="primary"
                           textColor="primary"
                           variant="fullWidth">
                       <Tab {...a11yProps(0)} label="Open Jobs"
                                              value={0}/>
                       <Tab {...a11yProps(1)} label="Closed Jobs"
                                              value={1}/>
                       <Tab {...a11yProps(2)} label="Assets"
                                             value={2}/>
                       <Tab {...a11yProps(3)} label="Sites"
                                              value={3}/>
                     </Tabs>
                   </AppBar>
                   <TabPanel value={tabValue} index={0}>
                      {showOpenJobs && <CustomerOpenJobs id={customer.id} name={customer.name}/>}
                    </TabPanel>
                    <TabPanel value={tabValue} index={1}>
                      {showClosedJobs && <ClosedJobs id={customer.id} name={customer.name}/>}
                    </TabPanel>
                    <TabPanel value={tabValue} index={2}>
                      {showAssets && <Assets id={customer.id}/>}
                    </TabPanel>
                    <TabPanel value={tabValue} index={3}>
                      {showSites && <Sites id={customer.id}/>}
                    </TabPanel>

                  </Widget>

            </Grid>
        </Grid>
      }
      {customer !== undefined && customer !== null &&
        <Dialog open={openResetXeroContactDialog} onClose={handleCloseResetXeroContactDialog} disableBackdropClick={true}

            PaperProps={{
              style: {
                boxShadow: 'none',
              },
            }}
        >
          <DialogTitle className={classes.title}>Are you sure?</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {`You are about to reset Xero contact for ${customer.name} (${customer.id}).`}
            </DialogContentText>

          </DialogContent>
          <DialogActions>
              <Button onClick={handleCloseResetXeroContactDialog}>
                Cancel
              </Button>
              <Button onClick={resetXeroContact} disabled={isResetingXeroContact}>
                {isResetingXeroContact && <span><CircularProgress size={25} color={'inherit'} /> Resetting...</span>}
                {!isResetingXeroContact && <span>RESET</span>}
              </Button>
          </DialogActions>
        </Dialog>
      }

      { customer !== undefined && customer !== null &&
        <Dialog open={openCreateSiteDialog} onClose={handleCloseCreateSiteDialog} disableBackdropClick={true} maxWidth="lg"

            PaperProps={{
              style: {
                boxShadow: 'none',
                width: '100%'
              },
            }}
        >
          <DialogTitle className={classes.title}>CREATE SITE</DialogTitle>
              <DialogContent>
                  <DialogContentText>
                    <CreateSite ref={createSiteRef}
                              createdSite={createdSite}
                              onFormUpdated={onCreateSiteFormUpdated}
                              onSiteUpdated={onCreateSiteUpdated}
                              onSiteCreated={onSiteCreated}/>
              </DialogContentText>

          </DialogContent>
          <DialogActions>
              <Button onClick={handleCloseCreateSiteDialog}>
                Cancel
              </Button>
              <Button onClick={createSite} disabled={isCreatingSite || !isCreateSiteValid}>
                {isCreatingSite && <span><CircularProgress size={25} color={'inherit'} /> Creating Site...</span>}
                {!isCreatingSite && <span>CREATE</span>}
              </Button>
          </DialogActions>
        </Dialog>

      }

      <CustomerDownloadCSVConfirmation ref={customerDownloadCSVConfirmationRef} closeMenu={handleClose}/>





    </div>
  );
});
export default EditCustomer;
